export default __webpack_public_path__ + "static/banner_1_1-ffd6869359fa4189888815a2221f8b0a.jpg";